import Vue from "vue";
import VueRouter from "vue-router";

//页面
import home from "./pages/home";
import research from "./pages/research";
import dataCenter from "./pages/research/dataCenter";
import forward from "./pages/forward";
import news from "./pages/news";
import about from "./pages/about";
import join from "./pages/join";
import joindetail from "./pages/join/detail.vue";
import newscontent from "./pages/news/content.vue";
import smartTransportation from "./pages/product/smartTransportation.vue";

Vue.use(VueRouter);

const routes = [
    // {
    //   name:"home",
    //   path:"/:lang/home",
    //   component: home
    // },
    {
      name:"home",
      path:'/zh-CN/home',
      component: home,
      meta:{
        title: "岭南大数据研究院"
      },
      alias:"/"
    },
    {
      path:'/:lang/home',
      component: home,
      meta:{
        title: "Big Data Institute"
      }
    },
    // { path: '/:lang/home', redirect: '/' },
    { 
      name:"research",
      path: '/:lang/research', 
      component: research
    },
    {
      name:"dataCenter",
      path:"/:lang/research/dataCenter/:type?",
      component: dataCenter
    },
    {
      name:"drive",
      path:"/:lang/research/drive/:type?",
      component: dataCenter
    },
    {
      name:"artificial",
      path:"/:lang/research/artificial/:type?",
      component: dataCenter
    },
    {
      name:"perception",
      path:"/:lang/research/perception/:type?",
      component: dataCenter
    },
    { 
      path: '/:lang/product',
      redirect: function(route){
        return route.path+"/smartTransportation";
      }
    },
    {
      name:"smartTransportation",
      path: '/:lang/product/smartTransportation',
      component: smartTransportation
    },
    {
      name:"smartPark",
      path: '/:lang/product/smartPark',
      component: smartTransportation
    },
    {
      name:"cityService",
      path: '/:lang/product/cityService',
      component: smartTransportation
    },
    {
      name:"forward",
      path: '/:lang/forward',
      component: forward
    },
    {
      name:"dataReport",
      path: '/:lang/forward/dataReport',
      component: forward
    },
    {
      name:"achievements",
      path: '/:lang/forward/achievements/:type?',
      component: forward
    },
    {
      name:"news",
      path: '/:lang/news',
      component: news,
      redirect: function(route){
        return route.path+"/salon";
      }
    },
    {
      name:"content",
      path: '/:lang/news/:type/content/:id?',
      component: newscontent
    },
    {
      name:"salon",
      path: '/:lang/news/salon',
      component: news
    },
    {
      name:"salon",
      path: '/:lang/news/salon/:id',
      component: news
    },
    {
      name:"communication",
      path: '/:lang/news/communication',
      component: news
    },
    {
      name:"communication",
      path: '/:lang/news/communication/:id',
      component: news
    },
    {
      name:"forum",
      path: '/:lang/news/forum',
      component: news
    },
    {
      name:"forum",
      path: '/:lang/news/forum/:id',
      component: news
    },
    {
      name:"about",
      path: '/:lang/about',
      component: about,
      redirect: function(route){
        return route.path+"/brief";
      }
    },
    {
      name:"brief",
      path: '/:lang/about/brief',
      component: about
    },
    {
      name:"introduce",
      path: '/:lang/about/introduce',
      component: about
    },
    {
      name:"contact",
      path: '/:lang/about/contact',
      component: about
    },
    {
      name:"join",
      path: '/:lang/join',
      component: join
    },
    {
      name:"joindetail",
      path: '/:lang/join/detail/:id/:childid',
      component: joindetail
    },
    // { path: '/', redirect: '/zh-CN/' }  //Location
]

var router =  new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.params.lang == 'en') {
    document.title = 'Big Data Institute';
  } else {
    document.title = "岭南大数据研究院";
  }
  // let f = from.params.lang || (from.fullPath=='/zh-CN/home'||(from.fullPath=='/'&&from.name) ? 'zh-CN':undefined),
  //   t = to.params.lang || (to.fullPath=='/zh-CN/home'||(to.fullPath=='/'&&to.name) ? 'zh-CN':undefined);
  // if(t&&f&&(t != f)) 
  //   location.href = to.fullPath;
  // else
    next()
})
export default router;